module.exports = __webpack_public_path__ + "_terms.html";